import React, {useEffect, useState} from 'react';
import {PersonalLoanSoftQuote} from '@/components/PersonalLoanSoftQuote/pages-au/PersonalLoanSoftQuote';
import Metadata from '@/components/Metadata/Metadata';
import { SOFTQUOTE_METADATA } from '@/components/Metadata/Metadata.constants';
import {DatadogAppender} from '@/components/PersonalLoanSoftQuote/DatadogAppender';

export default (props) => {
  const hostname = props && props.location && props.location.hostname;
  const [component] = useState(<PersonalLoanSoftQuote props={props} />);

  useEffect(() => {
    if (hostname === 'quote.gemfinance.co.nz') {
      if (typeof window !== 'undefined') {
        window.location.replace('https://loans.portal.gemfinance.co.nz/s/retrieve');
      }
      return;
    }
    if (typeof window !== 'undefined'){
      window.location = '/personal-loans';
    }
  }, []);

  return (
    <>
      <Metadata {...SOFTQUOTE_METADATA} />
      <DatadogAppender />
      {component}
    </>
  );
};
